/* eslint-disable react/forbid-foreign-prop-types */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import objectHash from 'object-hash';
import Container from 'admin-components/components/Container';
import Text from 'admin-components/components/Text';
import validate from 'admin-components/utils/validate';

const getValidationState = (errors) => {
  if (errors.some((error) => error.severity === 'error')) {
    return 'error';
  }

  if (errors.some((error) => error.severity === 'submissionRequirement')) {
    return 'preventSubmission';
  }

  if (errors.some((error) => error.severity === 'warning')) {
    return 'warning';
  }

  return 'none';
};

const withValidation = (WrappedComponent) =>
  class ValidatedComponent extends Component {
    static propTypes = {
      onChange: PropTypes.func,
      onBlur: PropTypes.func,
      onSubmit: PropTypes.func,
      validators: PropTypes.arrayOf(
        PropTypes.shape({
          test: PropTypes.func.isRequired,
          trigger: PropTypes.oneOf(['onChange', 'onSubmit', 'onBlur']).isRequired,
          message: PropTypes.node.isRequired,
          severity: PropTypes.oneOf(['submissionRequirement', 'warning', 'error'])
        })
      ),
      ...WrappedComponent.propTypes
    };

    static defaultProps = {
      validators: [],
      loaded: false,
      ...WrappedComponent.defaultProps
    };

    state = {
      errors: []
    };

    static propDescriptions = {
      validators: 'Array of validations to be performed on the field or form, after a specified event #validation',
      ...WrappedComponent.propDescriptions
    };

    render() {
      const { onChange, onSubmit, onBlur, onFocus, validators, validationState, width, validationErrors = [], ...props } = this.props;
      const { errors } = this.state;

      return (
        <Container orientation="vertical" width={width}>
          <WrappedComponent
            {...props}
            onChange={(values) => {
              if (onChange) {
                onChange(values);
              }

              this.setState({ errors: validate(values, validators, 'onChange') });
            }}
            onSubmit={(values) => {
              if (onSubmit) {
                onSubmit(values);
              }
              this.setState({ errors: validate(values, validators, 'onSubmit') });
            }}
            onBlur={(values) => {
              if (onBlur) {
                onBlur(values);
              }
              this.setState({ errors: validate(values, validators, 'onBlur') });
            }}
            onFocus={(values) => {
              if (onFocus) {
                onFocus(values);
              }
              this.setState({ errors: validate(values, validators, 'onFocus') });
            }}
            onLoad={(values) => {
              const { loaded } = this.state;

              if (!loaded) {
                this.setState({
                  errors: validate(values, validators, 'onChange'),
                  loaded: true
                });
              }
            }}
            validationState={validationState || getValidationState(errors)}
          />
          {[...errors, ...validationErrors].filter((error) => error !== 'submissionRequirement').length > 0 && (
            <Container orientation="vertical" space="vertical">
              {[...errors, ...validationErrors].map(
                (error) =>
                  error.severity !== 'submissionRequirement' && (
                    <Container key={objectHash(error)} orientation="horizontal" verticalAlignment="center" spaceChildren="horizontal">
                      <Text severity={error.severity} key={objectHash(error.message)}>
                        {error.message}
                      </Text>
                    </Container>
                  )
              )}
            </Container>
          )}
        </Container>
      );
    }
  };

export default withValidation;
